import axiosInstance from './axios'
import { AxiosResponse } from 'axios'
import { IFiltersAddress } from '../store/address/types'

class AddressService {

    constructor(private apiVersion: string = 'v1') {
    }

    public async getAddressPerson(filters: IFiltersAddress): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(filters)
            return axiosInstance.get(`${this.apiVersion}/addresses/persons`, { params })
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            if (err instanceof Error) throw err
            throw new Error(err.message || 'Error fetching person address data')
        }
    }

    public async getAddressCompany(filters: IFiltersAddress): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(filters)
            return axiosInstance.get(`${this.apiVersion}/addresses/companies`, { params })
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            if (err instanceof Error) throw err
            throw new Error(err.message || 'Error fetching company address data')
        }
    }

    public async getAddressGeometryPerson(filters: IFiltersAddress): Promise<any> {
        try {
            let pathKey: 'circle' | 'polygon' | undefined

            // Determina o tipo de busca geométrica com base nos campos presentes em IFiltersAddress
            if (filters.radius !== undefined && filters.latitude !== undefined && filters.longitude !== undefined) {
                pathKey = 'circle'
            } else if (filters.latitudes && filters.latitudes.length > 0 && filters.longitudes && filters.longitudes.length > 0) {
                pathKey = 'polygon' // Ou 'rectangle' se a API diferenciar
            } else {
                throw new Error('Filtros geométricos inválidos. Para círculo, forneça latitude, longitude e radius. Para polígono, forneça arrays de latitudes e longitudes.')
            }

            const endpoint = `${this.apiVersion}/geoaddresses/${pathKey}/persons`
            const params: URLSearchParams = this.buildParams(filters) // buildParams agora lida com todos os campos de IFiltersAddress

            return axiosInstance.get(endpoint, { params })
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            if (err instanceof Error) throw err
            throw new Error(err.message || 'Error fetching geometry address data')
        }
    }


    public async getAddressGeometryCompany(filters: IFiltersAddress): Promise<any> {
        try {
            let pathKey: 'circle' | 'polygon' | undefined

            // Determina o tipo de busca geométrica com base nos campos presentes em IFiltersAddress
            if (filters.radius !== undefined && filters.latitude !== undefined && filters.longitude !== undefined) {
                pathKey = 'circle'
            } else if (filters.latitudes && filters.latitudes.length > 0 && filters.longitudes && filters.longitudes.length > 0) {
                pathKey = 'polygon' // Ou 'rectangle' se a API diferenciar
            } else {
                throw new Error('Filtros geométricos inválidos. Para círculo, forneça latitude, longitude e radius. Para polígono, forneça arrays de latitudes e longitudes.')
            }

            const endpoint = `${this.apiVersion}/geoaddresses/${pathKey}/companies`
            const params: URLSearchParams = this.buildParams(filters) // buildParams agora lida com todos os campos de IFiltersAddress

            return axiosInstance.get(endpoint, { params })
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            if (err instanceof Error) throw err
            throw new Error(err.message || 'Error fetching geometry address data')
        }
    }

    // Agora aceita apenas IFiltersAddress (ou undefined)
    public buildParams(filters?: IFiltersAddress): URLSearchParams {
        const params = new URLSearchParams()

        if (!filters) {
            return params
        }

        if (filters?.start_date) {
            params.append('start_date', String(filters.start_date))
        }
        if (filters?.end_date) {
            params.append('end_date', String(filters.end_date))
        }
        if (filters?.street) {
            params.append('street', String(filters.street))
        }
        if (filters?.number) {
            params.append('number', String(filters.number))
        }
        if (filters?.district) {
            params.append('district', String(filters.district))
        }
        if (filters?.city) {
            params.append('municipality', String(filters.city))
        }
        if (filters?.state) {
            params.append('uf', String(filters.state))
        }
        if (filters?.zipCode) {
            params.append('zip_code', String(filters.zipCode))
        }

        // Parâmetros de Geometria (agora também em IFiltersAddress)
        if (filters.radius !== undefined) {
            params.append('radius', String(filters.radius))
        }
        if (filters.latitude !== undefined && typeof filters.latitude === 'number') {
            params.append('latitude', String(filters.latitude))
        }
        if (filters.longitude !== undefined && typeof filters.longitude === 'number') {
            params.append('longitude', String(filters.longitude))
        }
        if (Array.isArray(filters.latitudes) && filters.latitudes.length > 0) {
            params.append('latitudes', filters.latitudes.join('/'))
        }
        if (Array.isArray(filters.longitudes) && filters.longitudes.length > 0) {
            params.append('longitudes', filters.longitudes.join('/'))
        }


        return params
    }
}

const addressService = new AddressService()

export default addressService
